export enum UserRole {
  User = "ROLE_USER",
  Admin = "ROLE_ADMIN",
}
